<template>
    <li>
        <slot/>
    </li>
</template>
<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class NavigationSubItem extends Vue {
    @Prop() href: string;
    @Prop() target: string;
    @Prop() title: string;
    @Prop() classes: string;
    @Prop({ default: false }) active: boolean;

    subItems: NavigationSubItem[] = [];

    mounted() {
        (this.$parent as any).registerSubItem(this);
    }

    registerSubItem(item: NavigationSubItem): void {
        this.subItems.push(item);
    }
}
</script>
